import { render, staticRenderFns } from "./Error500.vue?vue&type=template&id=4963d7b4&scoped=true&lang=pug&"
import script from "./Error500.vue?vue&type=script&lang=ts&"
export * from "./Error500.vue?vue&type=script&lang=ts&"
import style0 from "./Error500.vue?vue&type=style&index=0&id=4963d7b4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4963d7b4",
  null
  
)

export default component.exports